export default __webpack_public_path__ + "static/media/placeholder_text_dark_mode.5c94d285.svg";